import { createContext, useContext } from 'react';

const DataContext = createContext(null);

export const useData = () => {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error('useData must be used inside AppProvider');
  return ctx;
};

export default DataContext;
